import { replaceCharForURL } from "utils/string";
import {
	API_START,
	API_END,
	FETCH_GET_ORGANIZATIONS,
	REMOVE_ORGANIZATION_IMAGE,
	SET_ORGANIZATION_FILES_IMAGES,
	SET_ORGANIZATION_NAME,
	SET_ORGANIZATION_NAME_ERROR,
	SET_ORGANIZATION_LOCALIZATION,
	FETCH_ADD_ORGANIZATION,
	SET_FETCH_ADD_ORGANIZATION_RESULT,
	SET_FETCH_ADD_ORGANIZATION_FAILURE,
	SET_ORGANIZATIONMAP_FILES_IMAGES,
	REMOVE_ORGANIZATIONMAP_IMAGE,
	FETCH_UPDATE_ORGANIZATION,
	SET_FETCH_UPDATE_ORGANIZATION_FAILURE,
	SET_FETCH_UPDATE_ORGANIZATION_RESULT,
	RESET_ORGANIZATION,
	FETCH_GET_ORGANIZATION_DETAILS,
	SET_ORGANIZATION_DETAILS_RESULT,
	SET_ORGANIZATION_PHONE,
	SET_ORGANIZATION_PHONE_ERROR,
	CLEAR_ORGANIZATION_PHONE,
	SET_ORGANIZATION_ADDRESS,
	SET_ORGANIZATION_ZIP_CODE,
	SET_ORGANIZATION_CITY,
	SET_ORGANIZATION_FAX,
	CLEAR_ORGANIZATION_FAX,
	SET_ORGANIZATION_FAX_ERROR,
	SET_ORGANIZATION_WEB_SITE_URL,
	CLEAR_ORGANIZATION_WEB_SITE_URL,
	SET_ORGANIZATION_WEB_SITE_URL_ERROR,
	SET_ORGANIZATION_MAIL,
	CLEAR_ORGANIZATION_MAIL,
	FETCH_GET_CURRENT_ORGANIZATION_DETAILS,
	RESET_DATA,
	SET_CITY_USING_ZIPCODE_RESULT,
	SET_ADDRESS_USING_ZIPCODE_RESULT,
	SET_ORGANIZATION_SELECTED_CITY,
	SET_ORGANIZATION_SELECTED_ADDRESS,
	SET_ADDRESS_USING_COORDINATES_RESULT,
	SET_ORGANIZATION_SELECTED_ZIPCODE,
	SET_FETCH_DELETE_ORGANIZATION_FAILURE,
	SET_FETCH_DELETE_ORGANIZATION_RESULT,
	FETCH_DELETE_ORGANIZATION,
	SET_ORGANIZATION_REGISTER_KEY,
	SET_DELETE_ORGANIZATION_CONFIRMATION_NAME,
	ADD_ORGANIZATION_CHANNEL,
	DELETE_ORGANIZATION_CHANNEL,
	REORDER_ORGANIZATION_CHANNELS,
	ADD_ORGANIZATION_CITY,
	DELETE_ORGANIZATION_CITY,
	SET_ORGANIZATION_CUSTOM_URI,
	SET_ORGANIZATION_CUSTOM_URI_ERROR,
	SET_ORGANIZATIONS_NAMES,
	SET_ORGANIZATIONS_SORTED,
	SET_NEAR_CITIES,
	SET_ORGANIZATIONS_NAME_FILTER,
	SET_ORGANIZATION_STARS,
	SET_ORGANIZATION_VISIBLE,
	SET_ORGANIZATION_CHANNELS,
	SET_CITIES_TAGS,
	CLEAR_SNACK_MESSAGE,
	SET_NEIGHBORHOOD_CITY_CHANNELS
} from "../actions/types";
import { t } from "../services/i18n";
import { reorderById } from "utils/reorder";
const OTHER = "Autre ...";

const initialState = {
	isFetching: false,
	isFetchingList: false,
	organizations: [],
	_id: null,
	name: null,
	nameErrorMsg: null,
	customUri: null,
	customUriErrorMsg: null,
	addresses: {},
	customAddress: null,
	address: null,
	selectedAddress: OTHER,
	addressUpdated: false,
	zipCode: null,
	zipCodes: {},
	customZipCode: null,
	selectedZipCode: OTHER,
	zipCodeUpdated: false,
	customCity: null,
	city: null,
	selectedCity: OTHER,
	cities: {},
	webSiteUrl: null,
	loc: null,
	phone: null,
	phoneErrorMsg: null,
	phoneState: null,
	fax: null,
	faxState: null,
	faxErrorMsg: null,
	registerkey: null,
	files: [],
	snackErrorMsg: null,
	snackInfoMsg: null,
	newWizard: null,
	logoUri: null,
	mapUri: null,
	mapSmallUri: null,
	areEquipmentsReordered: false,
	source: null,
	destination: null,
	clearValidate: false,
	isValid: false,
	addressErrorMsg: null,
	zipCodeErrorMsg: null,
	cityErrorMsg: null,
	deleteConfirmationName: "",
	channels: {},
	channelsSuggestions: {},
	citiesTags: {},
	citiesSuggestions: {},
	organizationsNames: {},
	page: 1,
	limit: 5,
	hasNextPage: false,
	nextPage: 2,
	totalPages: 0,
	totalDocs: 0,
	sorted: [{ id: "_id", desc: true }],
	nameFilter: null,
	stars: 0,
	isVisible: true,
	ignoreWeather: false
};

function validatePhone(phone) {
	let phoneState = "success";
	const phoneRegex =
		/^[+][0-9]{1,4}[" "][(][0][)][1-9][" "][0-9]{2}[" "][0-9]{2}[" "][0-9]{2}[" "][0-9]{2}$/g;
	if (phone && !phoneRegex.test(phone)) {
		phoneState = "error";
	}
	return phoneState;
}

function validateUrl(url) {
	try {
		new URL(url);
		return "success";
	} catch (_) {
		return "error";
	}
}

function validateEmail(email) {
	var emailRex =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	if (emailRex.test(email)) {
		return "success";
	}
	return "error";
}

function keepState(state) {
	return {
		...initialState,
		organizationsNames: state.organizationsNames,
		page: state.page,
		hasNextPage: state.hasNextPage,
		totalPages: state.totalPages,
		totalDocs: state.totalDocs,
		limit: state.limit,
		// Keep the list filters while adding / editing an item
		sorted: state.sorted,
		nameFilter: state.nameFilter
	};
}

export default function organizationReducer(state = initialState, action = {}) {
	switch (action.type) {
		case API_START:
			if (action.payload === FETCH_GET_ORGANIZATIONS) {
				return {
					...state,
					isFetchingList: true
				};
			}
			if (
				action.payload === FETCH_GET_ORGANIZATION_DETAILS ||
				action.payload === FETCH_ADD_ORGANIZATION ||
				action.payload === FETCH_UPDATE_ORGANIZATION ||
				action.payload === FETCH_DELETE_ORGANIZATION ||
				action.payload === FETCH_GET_CURRENT_ORGANIZATION_DETAILS
			) {
				return {
					...state,
					isFetching: true,
					newWizard: null
				};
			}
			break;

		case RESET_DATA:
		case RESET_ORGANIZATION:
			return keepState(state);

		case CLEAR_SNACK_MESSAGE:
			return {
				...state,
				snackInfoMsg: null,
				snackErrorMsg: null
			};

		case SET_ORGANIZATIONS_NAME_FILTER:
			return {
				...state,
				nameFilter: action.value
			};

		case SET_NEAR_CITIES:
			if (action.entities.citiesNames) {
				return {
					...state,
					citiesTags: { ...action.entities.citiesNames, ...state.citiesTags }
				};
			}
			break;

		case SET_ORGANIZATION_CHANNELS:
			if (action.entities.channels) {
				return {
					...state,
					channels: { ...action.entities.channels, ...state.channels }
				};
			}
			break;

		case SET_NEIGHBORHOOD_CITY_CHANNELS:
			const { channels: channelsSuggestions = {} } = action.entities;
			for (const id of Object.keys(state.channels)) {
				delete channelsSuggestions[id];
			}
			return { ...state, channelsSuggestions };

		case ADD_ORGANIZATION_CHANNEL: {
			let ignoreWeather = state.ignoreWeather;

			if (action.value.channeltype === "WeatherChannel") {
				ignoreWeather = true;
			}
			return {
				...state,
				channels: {
					...state.channels,
					[action.value._id]: action.value
				},
				ignoreWeather
			};
		}

		case ADD_ORGANIZATION_CITY:
			return {
				...state,
				citiesTags: { ...state.citiesTags, [action.value._id]: action.value }
			};

		case REORDER_ORGANIZATION_CHANNELS:
			return {
				...state,
				channels: reorderById(state.channels, action.from, action.to)
			};

		case DELETE_ORGANIZATION_CHANNEL: {
			const channels = { ...state.channels };
			const channel = Object.values(channels)[action.index];
			let ignoreWeather = state.ignoreWeather;

			delete channels[channel._id];

			// if (
			// 	!channel.channeltype ||
			// 	!channel.channeltype.startsWith("Organization")
			// ) {
			// 	delete channels[channel._id];
			// }
			if (channel?.channeltype === "WeatherChannel") {
				ignoreWeather = false;
			}
			return {
				...state,
				channels,
				ignoreWeather
			};
		}

		case DELETE_ORGANIZATION_CITY: {
			const citiesTags = { ...state.citiesTags };
			delete citiesTags[Object.values(citiesTags)[action.index]._id];
			return {
				...state,
				citiesTags
			};
		}

		case SET_CITIES_TAGS:
			const { citiesNames: citiesSuggestions = {} } = action.entities;
			for (const id of Object.keys(state.citiesTags)) {
				delete citiesSuggestions[id];
			}
			return { ...state, citiesSuggestions };

		case SET_DELETE_ORGANIZATION_CONFIRMATION_NAME:
			return {
				...state,
				deleteConfirmationName: action.value
			};

		case SET_ORGANIZATIONS_NAMES:
			const { organizationsNames, infospages } = action.entities;
			const { page, hasNextPage, totalPages, totalDocs, limit } =
				infospages["1"];
			return {
				...state,
				organizationsNames: organizationsNames ? organizationsNames : {},
				page,
				hasNextPage,
				totalPages,
				totalDocs,
				limit
			};

		case SET_ORGANIZATIONS_SORTED: {
			return {
				...state,
				sorted: action.value
			};
		}

		case SET_ADDRESS_USING_ZIPCODE_RESULT:
		case SET_ADDRESS_USING_COORDINATES_RESULT: {
			const gouvData = action.payload;
			if (gouvData && gouvData.features && gouvData.features.length > 0) {
				// Sort data by distance
				const sortedData = gouvData.features.sort(function (obj1, obj2) {
					if (obj1.properties && obj2.properties) {
						return obj1.properties.distance - obj2.properties.distance;
					} else {
						return 0;
					}
				});
				const addresses = {};
				const zipCodes = {};
				const cities = {};
				let address = null;
				// eslint-disable-next-line
				for (const val of sortedData) {
					if (
						val.properties !== null &&
						val.properties.postcode !== null &&
						val.properties.name !== null &&
						val.properties.city !== null
					) {
						if (!address) {
							address = val.properties.name;
						}
						addresses[val.properties.name] = {
							city: val.properties.city,
							zipCode: val.properties.postcode,
							loc: val.geometry
						};
						zipCodes[val.properties.postcode] = {
							city: val.properties.city,
							loc: val.geometry
						};
						cities[val.properties.city] = {
							loc: val.geometry
						};
					}
				}
				if (Object.keys(addresses).length > 0) {
					return {
						...state,
						addressUpdated: false,
						addresses,
						selectedAddress: address,
						address,
						zipCodes,
						selectedZipCode: addresses[address].zipCode,
						zipCode: addresses[address].zipCode,
						cities,
						selectedCity: addresses[address].city,
						city: addresses[address].city,
						loc: addresses[address].loc
					};
				}
			}
			break;
		}

		case SET_CITY_USING_ZIPCODE_RESULT: {
			const gouvData = action.payload;
			if (gouvData && gouvData.features && gouvData.features.length > 0) {
				const zipCodes = {};
				const cities = {};
				let zipCode = null;
				// eslint-disable-next-line
				for (const val of gouvData.features) {
					if (
						val.properties !== null &&
						val.properties.postcode === state.zipCode &&
						val.geometry !== null &&
						val.geometry.coordinates !== null &&
						val.geometry.coordinates.length === 2 &&
						!cities[val.properties.city]
					) {
						zipCodes[val.properties.postcode] = {
							city: val.properties.city,
							loc: val.geometry
						};
						if (!zipCode) {
							zipCode = val.properties.postcode;
						}
						cities[val.properties.city] = {
							loc: val.geometry
						};
					}
				}
				if (Object.keys(cities).length > 0) {
					return {
						...state,
						zipCodeUpdated: false,
						zipCodes,
						selectedZipCode: zipCode,
						zipCode,
						cities,
						selectedCity: zipCodes[zipCode].city,
						city: zipCodes[zipCode].city,
						loc: zipCodes[zipCode].loc
					};
				}
			}
			return {
				...state,
				zipCodeUpdated: false
			};
		}

		case SET_ORGANIZATION_STARS:
			return {
				...state,
				stars: action.payload
			};

		case SET_ORGANIZATION_VISIBLE:
			return {
				...state,
				isVisible: action.value
			};

		case SET_ORGANIZATION_SELECTED_ADDRESS: {
			if (action.payload === OTHER) {
				return {
					...state,
					selectedAddress: action.payload,
					address: state.customAddress
				};
			} else {
				const address = state.addresses[action.payload];
				return {
					...state,
					selectedZipCode: address.zipCode,
					zipCode: address.zipCode,
					city: address.city,
					selectedCity: address.city,
					selectedAddress: action.payload,
					address: action.payload,
					loc: address.loc
				};
			}
		}

		case SET_ORGANIZATION_SELECTED_ZIPCODE: {
			if (action.payload === OTHER) {
				return {
					...state,
					selectedZipCode: action.payload,
					zipCode: state.customZipCode
				};
			} else {
				const zipCode = state.zipCodes[action.payload];
				return {
					...state,
					selectedZipCode: action.payload,
					zipCode: action.payload,
					city: zipCode.city,
					selectedCity: zipCode.city,
					loc: zipCode.loc
				};
			}
		}

		case SET_ORGANIZATION_SELECTED_CITY:
			if (action.payload === OTHER) {
				return {
					...state,
					selectedCity: action.payload,
					city: state.customCity
				};
			} else {
				return {
					...state,
					selectedCity: action.payload,
					city: action.payload,
					loc: state.cities[action.payload].loc
				};
			}

		case SET_ORGANIZATION_DETAILS_RESULT: {
			const { organization, cities = {}, channels = {} } = action.entities;

			const {
				_id,
				name,
				customUri,
				address,
				zipCode,
				city,
				webSiteUrl,
				mail,
				loc,
				phone,
				fax,
				registerkey,
				logoUri,
				mapUri,
				mapSmallUri,
				stars,
				isVisible = true
			} = Object.values(organization)[0];

			const ignoreWeather = Boolean(
				Object.values(channels).filter(
					channel => channel.channeltype === "WeatherChannel"
				).length
			);
			return {
				...state,
				_id,
				name,
				customUri,
				address,
				customAddress: address,
				zipCode,
				customZipCode: zipCode,
				city,
				customCity: city,
				webSiteUrl,
				mail,
				loc,
				phone,
				fax,
				registerkey,
				logoUri,
				mapUri,
				mapSmallUri,
				newWizard: "update",
				channels,
				citiesTags: cities,
				stars,
				isVisible,
				ignoreWeather
			};
		}

		case SET_ORGANIZATION_LOCALIZATION:
			return {
				...state,
				loc: action.value
			};

		case SET_ORGANIZATION_PHONE:
			return {
				...state,
				phone: action.value,
				phoneState: validatePhone(action.value),
				phoneErrorMsg: null
			};

		case CLEAR_ORGANIZATION_PHONE:
			return {
				...state,
				phone: null,
				phoneState: null,
				phoneErrorMsg: null
			};

		case SET_ORGANIZATION_PHONE_ERROR:
			return {
				...state,
				phoneErrorMsg: t("profile:invalidphone")
			};

		case SET_ORGANIZATION_FAX:
			return {
				...state,
				fax: action.value,
				faxState: validatePhone(action.value),
				faxErrorMsg: null
			};

		case CLEAR_ORGANIZATION_FAX:
			return {
				...state,
				fax: null,
				faxState: null,
				faxErrorMsg: null
			};

		case SET_ORGANIZATION_FAX_ERROR:
			return {
				...state,
				faxErrorMsg: t("organization:invalidfax")
			};

		case SET_ORGANIZATION_WEB_SITE_URL:
			return {
				...state,
				webSiteUrl: action.value,
				webSiteUrlState: validateUrl(action.value),
				webSiteUrlErrorMsg: null
			};

		case CLEAR_ORGANIZATION_WEB_SITE_URL:
			return {
				...state,
				webSiteUrl: null,
				webSiteUrlState: null,
				webSiteUrlErrorMsg: null
			};

		case SET_ORGANIZATION_WEB_SITE_URL_ERROR:
			return {
				...state,
				webSiteUrlErrorMsg: t("gooddeal:invalidurl")
			};

		case SET_ORGANIZATION_MAIL:
			return {
				...state,
				mail: action.value,
				mailState: validateEmail(action.value),
				mailErrorMsg: null
			};

		case CLEAR_ORGANIZATION_MAIL:
			return {
				...state,
				mail: null,
				mailState: null,
				mailErrorMsg: null
			};

		case SET_ORGANIZATION_ADDRESS:
			return {
				...state,
				customAddress: action.value,
				address: action.value,
				addressErrorMsg: null,
				addressUpdated: true
			};

		case SET_ORGANIZATION_ZIP_CODE:
			return {
				...state,
				customZipCode: action.value,
				zipCode: action.value,
				zipCodeUpdated: true,
				zipCodeErrorMsg: null
			};

		case SET_ORGANIZATION_CITY:
			return {
				...state,
				customCity: action.value,
				city: action.value,
				cityErrorMsg: null
			};

		case SET_ORGANIZATION_FILES_IMAGES:
			return {
				...state,
				files: [
					...state.files.filter(file => file.out !== "logoUri"),
					...action.payload
				],
				logoUri: null
			};

		case REMOVE_ORGANIZATION_IMAGE: {
			return {
				...state,
				files: [...state.files.filter(file => file.out !== "logoUri")],
				logoUri: null
			};
		}

		case SET_ORGANIZATIONMAP_FILES_IMAGES:
			return {
				...state,
				files: [
					...state.files.filter(
						file => file.out !== "mapUri" && file.out !== "mapSmallUri"
					),
					...action.payload
				],
				mapUri: null,
				mapSmallUri: null
			};

		case REMOVE_ORGANIZATIONMAP_IMAGE:
			return {
				...state,
				files: [
					...state.files.filter(
						file => file.out !== "mapUri" && file.out !== "mapSmallUri"
					)
				],
				mapUri: null,
				mapSmallUri: null
			};

		case SET_ORGANIZATION_NAME:
			if (state.newWizard) {
				return {
					...state,
					name: action.value,
					nameErrorMsg: null
				};
			} else {
				let customUri = "";
				if (action.value) {
					for (const c of action.value) {
						customUri += replaceCharForURL(c);
					}
				}
				return {
					...state,
					customUri,
					customUriErrorMsg: null,
					name: action.value,
					nameErrorMsg: null
				};
			}

		case SET_ORGANIZATION_CUSTOM_URI:
			return {
				...state,
				customUri: action.value,
				customUriErrorMsg: null
			};

		case SET_ORGANIZATION_REGISTER_KEY:
			return {
				...state,
				registerkey: action.value
			};

		case SET_ORGANIZATION_NAME_ERROR:
			return {
				...state,
				nameErrorMsg: t("organization:namemandatory")
			};

		case SET_ORGANIZATION_CUSTOM_URI_ERROR:
			return {
				...state,
				customUriErrorMsg: t("organization:urimandatory")
			};

		case SET_FETCH_ADD_ORGANIZATION_RESULT:
			return {
				...keepState(state),
				snackInfoMsg: t("organization:addsuccess")
			};

		case SET_FETCH_DELETE_ORGANIZATION_RESULT:
			return {
				...state,
				snackInfoMsg: t("organization:deletesuccess")
			};

		case SET_FETCH_UPDATE_ORGANIZATION_RESULT:
			return {
				...keepState(state),
				snackInfoMsg: t("organization:updatesuccess")
			};

		case SET_FETCH_ADD_ORGANIZATION_FAILURE:
			return {
				...state,
				snackErrorMsg: t("organization:adderror")
			};

		case SET_FETCH_UPDATE_ORGANIZATION_FAILURE:
			return {
				...state,
				snackErrorMsg: t("organization:updateerror")
			};

		case SET_FETCH_DELETE_ORGANIZATION_FAILURE:
			return {
				...state,
				snackErrorMsg: t("organization:deleteerror")
			};

		case API_END:
			if (action.payload === FETCH_GET_ORGANIZATIONS) {
				return {
					...state,
					isFetchingList: false
				};
			}
			if (
				action.payload === FETCH_GET_ORGANIZATION_DETAILS ||
				action.payload === FETCH_ADD_ORGANIZATION ||
				action.payload === FETCH_UPDATE_ORGANIZATION ||
				action.payload === FETCH_DELETE_ORGANIZATION ||
				action.payload === FETCH_GET_CURRENT_ORGANIZATION_DETAILS
			) {
				return {
					...state,
					isFetching: false
				};
			}
			break;

		default:
			return state;
	}
	return state;
}
